(ns frontend.ui.component.tab-layout.view
  (:require
   [frontend.ui.component.tab-layout.style :as style]
   [herb.core :refer [<class]]
   [reagent.core :as r]))

(defn- tab-title
  [title switch-tab selected?]
  [:span
   {:class    (<class style/tab-title selected?)
    :on-click switch-tab}
   title])

(defn- header
  [switch-tab selected children]
  [:div
   {:class (<class style/header)}
   (for [[id {title :title}] children]
     ^{:key id}
     [tab-title title #(switch-tab id) (= id selected)])])

(defn- body
  [child]
  [:div
   {:class (<class style/body)}
   child])

(defn tab-layout
  [{:keys [selected on-tab-change]} children]
  (let [selected (r/atom selected)
        switch-tab (fn [tab-key]
                     (reset! selected tab-key)
                     (when (fn? on-tab-change)
                       (on-tab-change tab-key)))]
    (fn []
      [:div
       [header switch-tab @selected children]
       (when-let [child (get-in children [@selected :body])]
         [body
          child])])))
